/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import {
    NbMenuModule,
    NbSidebarModule,
    NbToastrModule,
    NbWindowModule,
} from '@nebular/theme';
import { PrivacyPolicyComponent } from './@components/privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from './@components/terms-and-conditions/terms-and-conditions.component';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { routes } from './app-routing.module';
import { AppComponent } from './app.component';
import { OAuth2Module } from './modules/oauth2/oauth2.module';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { environment } from '../environments/environment';
import { AlertMessageComponent } from './@components/alert-message/alert-message.component';
import { ApiModule } from './api/api.module';
import { provideRouter, RouterOutlet } from '@angular/router';
import { LoaderComponent } from './@theme/components/loader/loader.component';


@NgModule({
    declarations: [AppComponent],
    providers: [
        provideAnimations(),
        provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
        provideAuth(() => getAuth()),
        provideRouter(routes),
        provideHttpClient(withInterceptorsFromDi()),
    ],
    imports: [
        AlertMessageComponent,
        PrivacyPolicyComponent,
        TermsAndConditionsComponent,
        ApiModule,
        BrowserModule,
        BrowserAnimationsModule,
        NbSidebarModule.forRoot(),
        NbMenuModule.forRoot(),
        NbWindowModule.forRoot(),
        NbToastrModule.forRoot(),
        CoreModule.forRoot(),
        ThemeModule.forRoot(),

        OAuth2Module,
        MatButtonModule,
        MatIconModule,
        MatMomentDateModule,
        MatSnackBarModule,
        LoaderComponent,
        RouterOutlet,
    ],
    bootstrap: [AppComponent],

})
export class AppModule {}
